import { NumberModel } from "@src/utils/models";
import { useEffect } from "react";
import { useInvoiceStore } from "../store";

export const useInitInvoiceItem = () => {
  const store = useInvoiceStore();

  useEffect(() => {
    if (store.form.invoice_items.$.length === 0) {
      store.form.addInvoiceItem({
        description: "",
        quantity: "",
        unit_price: "0",
        amount_in_currency: new NumberModel(
          0,
          store.selectedCurrency.denomination,
        ),
        accounting_account_id: "",
        cost_center_id: undefined,
        tag_ids: [],
        vat_percent_informative: store.form.vat_percent_informative.$ ?? "0",
      });
    }
  }, []);
};
